"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Layer = _interopRequireDefault(require("./Layer"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
/* eslint-disable spaced-comment */
/// <reference path="../../../../../../node_modules/@types/openlayers/index.d.ts" />
/* eslint-enable spaced-comment */

class OpenLayersPolylineLayer extends _Layer.default {
  constructor(layer, points) {
    let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    super(layer, opts, id);
    this._points = points;
  }
  invalidate() {
    this.createRenderable();
    if (this.map) {
      const map = this.map;
      this.remove();
      this.addTo(map, this._targetIndex);
    }
  }
  createRenderable() {
    const {
      stroke
    } = this.opts;
    // points.push(ol.proj.transform([xx,yy],'EPSG:4326', 'EPSG:3857'));
    const points = this._points.map(point => ol.proj.transform([point.lon, point.lat], 'EPSG:4326', 'EPSG:3857'));
    const feature = new ol.Feature({
      properties: {
        id: this.id
      },
      geometry: new ol.geom.LineString(points)
    });
    this.source = new ol.source.Vector();
    this.source.addFeature(feature);
    return new ol.layer.Vector({
      source: this.source,
      style: new ol.style.Style({
        stroke: stroke ? new ol.style.Stroke(stroke) : null
      })
    });
  }
}
var _default = exports.default = OpenLayersPolylineLayer;
module.exports = exports.default;